import { colors } from '../colors/raw';

export default {
  colors: {
    ...colors,
    primary: colors['primary/1000'],
    darkPrimary: colors['blue/1000'],
    darkGrey: colors['grey/1200'],
    lightGrey: colors['grey/400'],
    extraLightGrey: colors['grey/100'],
    mediumGrey: colors['grey/600'],
    orange: colors['orange/600'],
    red: colors['red/600'],
  },
};
